import { ErrorHandler } from '@angular/core';
import { isAnonymousAuthRejection } from '@core/helpers';

// Не отправляем в Sentry/консоль синтетические 401 анонима из AuthInterceptor:
// это ожидаемый deep-link login flow, а не ошибка приложения.
export class AppErrorHandler implements ErrorHandler {
  constructor(private readonly delegate: ErrorHandler) {}

  handleError(error: unknown): void {
    if (isAnonymousAuthRejection(error)) {
      return;
    }

    this.delegate.handleError(error);
  }
}
